import { MobileRowLayout } from "./types";

export const mobileRowPositionDataPLACEHOLDER: MobileRowLayout = {
  width: 0,
  height: 0,
  cellEntities: [],
  delimiters: {},
};
